<template>
  <b-modal id="modal-dialog" ref="modal-dialog" size="xl" :title="'test'" @hidden="clearModalData">
    <!-- Modal body for all modals -->
    <p class="my-4" v-if="this.body && this.body.length > 0">{{ this.body }}</p>
    <!-- regular input modal -->
    <b-input v-model="inputValue" :placeholder="inputPlaceholder"></b-input>
    <!-- modal buttons -->
    <div slot="modal-footer" class="w-100">
      <b-button variant="primary" v-if="confirmText" class="float-right mx-2" @click="modalConfirm">{{ confirmText
        }}</b-button>
      <b-button variant="light" v-if="cancelText" class="float-right mx-2" @click="modalCancel">{{ cancelText
        }}</b-button>
    </div>
  </b-modal>
</template>

<script>
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  mixins: [mediaMixin],
  components: {},
  data() {
    return {
      title: '',
      body: '',
      cbConfirm: null,
      cbCancel: null,
      confirmText: '',
      cancelText: '',
      inputValue: '',
      inputPlaceholder: 'https://...',
    };
  },
  created() {
    this.$root.$on('modal-show-upload-url', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('modal-show-upload-url', this.showModal);
  },
  methods: {
    showModal({
      title,
      body,
      cbConfirm,
      cbCancel,
      confirmText,
      cancelText,
    }) {
      this.title = title;
      this.body = body;
      this.cbConfirm = cbConfirm || null;
      this.cbCancel = cbCancel || null;
      this.confirmText = confirmText;
      this.cancelText = cancelText;
      this.inputValue = '';
      this.$refs['modal-dialog'].show();
    },
    hideModal() {
      this.$refs['modal-dialog'].hide();
    },
    clearModalData() {
      this.title = null;
      this.body = null;
      this.cbConfirm = null;
      this.cbCancel = null;
      this.confirmText = null;
      this.cancelText = null;
      this.inputValue = null;
    },
    modalConfirm() {
      if (this.cbConfirm) {
        if (this.inputValue) this.cbConfirm(this.inputValue);
      }
      this.hideModal();
    },
    modalCancel() {
      if (this.cbCancel) this.cbCancel();
      this.hideModal();
    },
  },
};
</script>
